import { useCallback, useState } from 'react';
export function useDropdownBaseToggler() {
  const [open, setOpen] = useState(false);
  const openDropdown = useCallback(() => setOpen(true), []);
  const closeDropdown = useCallback(() => setOpen(false), []);
  const toggleWithKeyPress = useCallback(e => {
    const keys = ['ArrowDown', 'Enter'];
    if (keys.includes(e.key)) {
      openDropdown();
    }
    if (e.key === 'Escape') {
      closeDropdown();
    }
  }, [openDropdown, closeDropdown]);
  const toggleOpen = useCallback(() => setOpen(old => !old), []);
  return {
    open,
    openDropdown,
    closeDropdown,
    toggleOpen,
    toggleWithKeyPress
  };
}